import { render, staticRenderFns } from "./manageInteressadosRouter.vue?vue&type=template&id=72f88d53"
import script from "./manageInteressadosRouter.vue?vue&type=script&lang=js"
export * from "./manageInteressadosRouter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports